import { NgModule } from '@angular/core';
import { ExpenseService } from './expense.service';
import { ExpenseBackend } from './expense.backend';

@NgModule({
  providers: [ExpenseService, ExpenseBackend],
})
export class ExpenseModule {}
